import { Link } from "react-router-dom";
import useFetch from "../../Hooks/useFetch";
import styles from "./assets/css/PremiumBrands.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useEffect, useState } from "react";

import tyreTracks from "./assets/images/tyre_tracks.webp";

const PremiumBrands = () => {
  const { data: premiumBrandsData, error } = useFetch("premium_brands");
  const [premiumBrands, setPremiumBrands] = useState([]);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!premiumBrandsData) return;
    const filteredSortedBrands = premiumBrandsData
      .filter((brand) => brand.acf.premium_brands.show_on_home_page)
      .sort((a, b) => a.acf.premium_brands.order - b.acf.premium_brands.order);
    setPremiumBrands(filteredSortedBrands);
  }, [premiumBrandsData]);

  const settings = {
    dots: true,
    speed: 1000,
    infinite: true,
    slidesToShow: 3,
    autoplaySpeed: 3000,
    className: "premium-brands-slider",
    dotsClass: "premium-brands-dots",
    swipeToSlide: true,
    centerMode: true,
    autoplay: true,
    arrows: false,
    focusOnSelect: true,
    hoverPause: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.inView);
            // remove intersection observer after first inView
            observer.unobserve(entry.target);
            setInView(true);
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = document.querySelectorAll(".premium-brands-slider");
    elements.forEach((element) => {
      observer.observe(element);
    });
    return () => {
      elements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <section className={styles.premiumBrands}>
      <img className={styles.tyreTracks} src={tyreTracks} alt="Tyre tracks" />
      {error ? (
        ""
      ) : (
        <>
          <h3 className={`${styles.sectionTitle} ${inView && styles.inView}`}>
            Premium Brands
          </h3>
          <Slider {...settings}>
            {premiumBrands &&
              premiumBrands.map((brand) => (
                <div className={styles.transparentContainer} key={brand.id}>
                  <div className={styles.brand}>
                    <div className="overlay"></div>
                    {brand.acf.premium_brands.use_alternative_logo ? (
                      <img
                        src={
                          brand.acf.premium_brands.alternative_logo.sizes
                            .medium_large
                        }
                        alt={brand.acf.premium_brands.alternative_logo.alt}
                        width={
                          brand.acf.premium_brands.alternative_logo.sizes[
                            "medium_large-width"
                          ]
                        }
                        height={
                          brand.acf.premium_brands.alternative_logo.sizes[
                            "medium_large-height"
                          ]
                        }
                        className={styles.brandLogo}
                      />
                    ) : (
                      <img
                        src={
                          brand.acf.premium_brands.brand_logo.sizes.medium_large
                        }
                        alt={brand.acf.premium_brands.brand_logo.alt}
                        width={
                          brand.acf.premium_brands.brand_logo.sizes[
                            "medium_large-width"
                          ]
                        }
                        height={
                          brand.acf.premium_brands.brand_logo.sizes[
                            "medium_large-height"
                          ]
                        }
                        className={styles.brandLogo}
                      />
                    )}
                    <p className={styles.brandText}>
                      {brand.acf.premium_brands.brand_description}
                    </p>
                    <Link
                      to={`/brands?brand=${brand.title.rendered}`}
                      className={styles.brandLink}
                    >
                      Find out more
                    </Link>
                    <div className={styles.productContainer}>
                      <img
                        src={
                          brand.acf.premium_brands.product_image.sizes
                            ?.medium_large
                        }
                        height={
                          brand.acf.premium_brands.product_image?.sizes[
                            "medium_large-height"
                          ]
                        }
                        width={
                          brand.acf.premium_brands.product_image?.sizes[
                            "medium_large-width"
                          ]
                        }
                        alt={brand.acf.premium_brands.product_image.alt}
                        className={styles.brandProduct}
                      />
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </>
      )}
    </section>
  );
};
export default PremiumBrands;
